import React, { Component } from "react";
import { Container, Row } from "reactstrap";

//Import Section Title
//import ActionBox from "./action-box";
import { Link } from "react-router-dom";
import * as Icon from 'react-feather';

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

import footerlogo from "../../assets/images/logo/horizontal.svg";

class Actions extends Component {
  

  state = {
    howWorksVisible: false,
    contactVisible: false
  }

  constructor(props) {
    super(props);
    window.setTimeout(() => {
      this.setState({ howWorksVisible: true });
    }, 7000);
  }

  showHowWorks() {
    this.setState({ howWorksVisible: true });
  }

  hideHowWorks() {
    this.setState({ howWorksVisible: false });
  }

  showContact() {
    this.setState({ contactVisible: true });
  }

  hideContact() {
    this.setState({ contactVisible: false });
  }

  render() {
    return (
      <React.Fragment>
        {/* SERVICE START  */}
        <section id="actions" className="section bg-light-gray position-relative pt-2 pb-2 pt-md-5 pb-md-5">
          <Container className="pt-4 pb-4">
            <Row className="col-lg-8 mx-auto action-holder">
              <a href="/consultation/start" className="text-center d-block col-6 pl-2 pr-2">
                <div className="btn btn-derma w-100 action-box">
                  <Icon.ArrowUpCircle className="w-100 text-white icon-size-60" />
                  <h5 className="text-white font-weight-medium mb-3 mt-3">
                    Start consultation<br/>online
                  </h5>
                </div>
              </a>

              <Link to="/dermatologists" className="text-center d-block col-6 pl-2 pr-2">
                <div className="action-box w-100 bg-white">
                  <Icon.Search className="w-100 action-icon icon-size-60" />
                  <h5 className="text-dark-gray font-weight-medium action-title mb-3 mt-3">
                    Find a<br/>dermatologist
                  </h5>
                </div>
              </Link>

              <Link to="#how-it-works" onClick={this.showHowWorks.bind(this)} className="text-center d-block col-6 pl-2 pr-2">
                <div className="action-box w-100 bg-white">
                  <Icon.HelpCircle className="w-100 action-icon icon-size-60" />
                  <h5 className="text-dark-gray font-weight-medium action-title mb-3 mt-3">
                    How it<br/>works
                  </h5>
                </div>
              </Link>

              <Link to="#contact" onClick={this.showContact.bind(this)} className="text-center d-block col-6 pl-2 pr-2">
                <div className="action-box w-100 bg-white">
                  <Icon.PhoneCall className="w-100 action-icon icon-size-60" />
                  <h5 className="text-dark-gray font-weight-medium action-title mb-3 mt-3">
                    Contact<br/>us
                  </h5>
                </div>
              </Link>
            </Row>
          </Container>
          <Modal center="true" open={this.state.howWorksVisible} onClose={this.hideHowWorks.bind(this)}>
            <h4>How it works</h4>
            <hr />
            <div class="mt-3 row">
              <div class="col-12 xs-margin-20px-bottom text-center margin-80px-bottom">
                <div class='embed-container'><iframe src='https://www.youtube.com/embed/f19uiGaS7cM' frameborder='0' allowfullscreen></iframe></div>
              </div>
            </div>
            <div class="mt-3 row align-items-center justify-content-center margin-80px-bottom xs-margin-40px-bottom" style={{color: '#434343'}}>
              <div class="col-lg-4 col-md-5 xs-margin-20px-bottom text-center">
                <div>
                  <img class="border-radius-4" style={{width: 280, borderWidth: 1, borderColor: '#e7e7e7', borderStyle: 'solid', borderRadius: 2}} src="/i/for-patients/howto-consult.png" alt="Image"/>
                </div>
              </div>
              <div class="col-lg-6 col-md-7">
                <div class="padding-40px-left sm-no-padding-left">
                  <div class="media">
                    <span class="number margin-20px-right">1</span>
                    <div class="media-body">
                      <h5 class="mt-0">Consult</h5> Our digital assistant will guide you through the online consultation, ask you about your medical history and take photos of your condition before sending it to a dermatologist
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-center justify-content-center margin-80px-bottom xs-margin-40px-bottom">
              <div class="col-lg-6 col-md-7 order-2 order-md-1 order-lg-1">
                <div class="padding-40px-right sm-no-padding-right">
                  <div class="media">
                    <span class="number margin-20px-right">2</span>
                    <div class="media-body">
                      <h5 class="mt-0">Pay</h5> Use Instant EFT, credit, cheque or debit cards to pay the dermatologist. Depending on your medical aid and plan, you'll be able to claim it back
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-5 order-1 order-md-2 order-lg-2 xs-margin-20px-bottom">
                <div>
                  <div class="text-right xs-text-center"><img class="border-radius-4" style={{width: 280, borderWidth: 1, borderColor: '#e7e7e7', borderStyle: 'solid', borderRadius: 2}} src="/i/for-patients/howto-pay.png" alt="Image"/></div>
                </div>
              </div>
            </div>
            <div class="row align-items-center justify-content-center pb-3">
              <div class="col-lg-4 col-md-5 xs-margin-20px-bottom text-center">
                <div>
                  <img class="border-radius-4" style={{width: 280, borderWidth: 1, borderColor: '#e7e7e7', borderStyle: 'solid', borderRadius: 2}} src="/i/for-patients/howto-diagnosis.png" alt="Image"/>
                </div>
              </div>
              <div class="col-lg-6 col-md-7">
                <div class="padding-40px-left sm-no-padding-left">
                  <div class="media">
                    <span class="number margin-20px-right">3</span>
                    <div class="media-body">
                      <h5 class="mt-0">Receive diagnosis</h5> You'll receive your diagnosis, prescription, additional information on your condition and a voicenote should your dermatologist wish to include one
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal className="contactus" center="true" open={this.state.contactVisible} onClose={this.hideContact.bind(this)}>
            <h4>Contact us</h4>
            <hr />
            <div className="row">
              <div className="col-12">
                <p class="text-dark-gray">
                  For support, questions or feedback, please feel free to get in contact
                </p>
                <div>
                  <ul className="list-group">
                    <li className="list-group-item m-0 p-0 border-0 text-dark-gray">
                      <i className="remixicon-mail-line mr-2" style={{fontSize: 22}}></i>
                      <a href="mailto:support@drderma.co.za" className="position-relative d-inline-block text-dark-gray" style={{top: -2}}>support@drderma.co.za</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="footer-about-content mt-4">
                  <ul className="list-inline footer-icon mt-4">
                    <li className="list-inline-item h4 mr-4">
                      <a className="text-muted-light" target="_blank" href="https://www.facebook.com/drderma.southafrica">
                        <i className="remixicon-facebook-line"></i>
                      </a>
                    </li>
                    <li className="list-inline-item h4 mr-4">
                      <a className="text-muted-light" target="_blank" href="https://www.instagram.com/dr_derma_sa">
                        <i className="remixicon-instagram-line"></i>
                      </a>
                    </li>
                    <li className="list-inline-item h4 mr-4">
                      <a className="text-muted-light" target="_blank" href="https://www.linkedin.com/company/dr-derma-southern-africa/">
                        <i className="remixicon-linkedin-line"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Modal>
        </section>

        {/* SERVICE END  */}
      </React.Fragment>
    );
  }
}

export default Actions;
